module.exports = __webpack_public_path__ + "9df74243d8aafd949285e1475b823d41.svg";